// extracted by css-extract-rspack-plugin
export default {"scrollDiv":"_6f5f0943"};